import { LEVEL_PRIORITY } from "../constants";

type LevelType = "Introductory" | "Intermediate" | "Advanced" | undefined;

export const getLevel = (
  levelArray: string[] | string | null | undefined,
): LevelType => {
  if (levelArray == null) return undefined;

  const levels = Array.isArray(levelArray) ? levelArray : [levelArray];

  // Find the level with highest priority (last in LEVEL_PRIORITY has highest priority)
  let highestPriorityLevel: string | undefined;
  let highestPriorityIndex = -1;

  for (const level of levels) {
    const priorityIndex = LEVEL_PRIORITY.indexOf(level);
    if (priorityIndex > highestPriorityIndex) {
      highestPriorityIndex = priorityIndex;
      highestPriorityLevel = level;
    }
  }

  // Fall back to first element if no level matched priority list
  return (highestPriorityLevel ?? levels[0]) as LevelType;
};
